<template>
  <div id="map-panel-container">
    <div class="map-wrapper">
      <div id="dialog-wrapper" v-bind:style="dialogStyle">
        <div id="dialog-name">{{ dialogStatus.name }}</div>
        <div id="dialog-count">{{ dialogStatus.count }}</div>
        <div id="dialog-close-btn"></div>
      </div>

      <GmapMap
        :center="center"
        v-bind:zoom="12"
        map-type-id="terrain"
        class="map"
        ref="google_map"
        :options="options"
        @click="mapClickHandler"
      >
        <div id="preloader" v-bind:style="loaderStyle">
          <div id="loader"></div>
        </div>

        <!-- <GmapMarker
          :key="m.id"
          v-for="m in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :animation="google.maps.Animation.BOUNCE"
          :label="m.id"
        ></GmapMarker> -->

        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :icon="{
            fillColor: '#FF8000',
            fillOpacity: 1.0,
            path: google.maps.SymbolPath.CIRCLE,
            scale: createScale(m.total_count),
            strokeColor: '#FF8000',
            strokeWeight: 1.0,
          }"
          :opacity="0.7"
          @click="toggleInfoWindow(m, index)"
        >
          <!-- <GmapInfoWindow @closeclick="openMarker(null)">
            Hello world!
          </GmapInfoWindow> -->
        </GmapMarker>
        <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div class="inner">
            <p>{{ selectMarker.pref_name }}</p>
            <p>{{ selectMarker.city_name }}</p>
            <p>{{ selectMarker.area_name }}</p>
          </div>
          <p>{{ selectMarker.total_count }}事例</p>
          <div class="inner">
            <button class="button close" @click="infoWinOpen = false">
              閉じる
            </button>
            <button
              class="button select"
              @click="appendSelectList(selectMarker)"
            >
              選択
            </button>
          </div>
        </GmapInfoWindow>

        <GmapMarker
          :key="'selected' + index"
          v-for="(m, index) in selectList"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :icon="{
            fillColor: '#ff0001',
            fillOpacity: 1.0,
            path: google.maps.SymbolPath.CIRCLE,
            scale: createScale(m.total_count),
            strokeColor: '#ff0001',
            strokeWeight: 1.0,
          }"
          :label="{
            text: String(index + 1),
            color: 'white',
          }"
          @click="clickMarker(index)"
        >
        </GmapMarker>
      </GmapMap>
      <!-- <div id="symbol">
        <div id="symbol-text">事例数（合計）</div>
        <div v-for="(color, index) in colors" :key="index" class="symbol-block">
          <div :style="{ 'background-color': color }" class="color-block"></div>
          <div>{{ range(index) }}</div>
        </div>
      </div> -->
    </div>
    <Panel
      :cityInfo="cityInfo"
      :checkList="checkList"
      :selectList="selectList"
      :yearFrom="yearFrom"
      :yearTo="yearTo"
    />
    <!-- <div v-for="(m, k) in selectList" :key="k">
      <p>{{ m }}</p>
    </div> -->
    <!-- {{ selectList }} -->
  </div>
</template>

<script>
// import PriceMapLegend from "@/components/mansionReport/PriceMapLegend";
import _ from "lodash";
import Panel from "@/components/Panel.vue";
import { gmapApi } from "vue2-google-maps";
import { getAreasCapRate } from "@/api/area";
import {
  getCoordinate,
  inPolygon,
  calculatePolygonCenter,
} from "@/utils/tools";

// const degreeArray = [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]
const degreeArray = [
  0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320,
  340,
];
const colors = [
  "rgba(205, 13, 34, 0.7)",
  "rgba(252,83,43, 0.7)",
  "rgba(253, 166, 71, 0.7)",
  "rgba(254, 225, 136, 0.7)",
  "rgba(0,0,0,0.7)",
];

const typeIdMapping = {
  CondoSingle: 1,
  CondoFamily: 2,
  BuildingWood: 3,
  BuildingNotWood: 4,
};

const idTypeMapping = {
  1: "CondoSingle",
  2: "CondoFamily",
  3: "BuildingWood",
  4: "BuildingNotWood",
};

export default {
  name: "GoogleMap",
  components: {
    Panel,
  },
  data() {
    return {
      openedMarkerID: null,
      center: { lat: 35.682955, lng: 139.686721 },
      options: {
        clickableIcons: false,
        streetViewControl: false,
      },
      checkList: [],
      edited: null,
      errorMessage: null,
      marker: {},
      loaded: false,
      polygons: [],
      multiPolygons: [],
      point: null,
      marker: null,
      degreeArray: degreeArray,
      cityInfo: {},
      _cityInfo: {},
      colors: colors,
      annual: 1970,
      enableAppendMode: false,
      distanceArray: [],
      distance: 5000,
      enableRequest: true,
      geocoder: null,
      dialogStatus: {
        display: "none",
        left: 0,
        top: 0,
        name: "",
        count: 0,
        noi: "",
      },
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -15,
        },
        minWidth: 200,
        minHeight: 300,
      },
      infoWindowPos: null,
      infoWinOpen: false,
      selectMarker: {
        id: null,
        count: null,
      },
      selectList: [],
      yearFrom: 1900,
      yearTo: 3000,
    };
  },

  methods: {
    appendSelectList(m) {
      let _selectList = [...this.selectList];
      this.selectList = null;
      _selectList.push(m);
      this.selectList = _selectList;
      this.infoWinOpen = false;
    },
    toggleInfoWindow(m, k) {
      // m["id"] = k;
      this.selectMarker = m;
      this.infoWindowPos = m.position;
      this.infoWinOpen = true;
    },
    createScale(count) {
      if (count > 10) {
        return 19;
      } else if (count > 5) {
        return 15;
      } else if (count > 1) {
        return 12;
      } else if (count == 1) {
        return 9;
      } else {
        return 0;
      }
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.marker.position = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.panToMarker();
          this._getAreaHandler(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (err) => {
          var lat = this.center.lat;
          var lng = this.center.lng;
          this._getAreaHandler(lat, lng);
        }
      );
    },
    panToMarker() {
      this.$refs.google_map.panTo(this.marker.position);
    },
    delayOneSecond() {
      // 処理が早すぎるので1秒待たせる（APIが動いているように見えない）
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1000);
      });
    },
    _getAreaHandler: function (lat, lng) {
      //   if (!this.enableRequest) {
      //     return;
      //   }

      this.enableRequest = false;

      //   var pointArray = [];

      //   for (const distance of this.distanceArray) {
      //     var pointGroup = [];
      //     for (const degree of this.degreeArray) {
      //       var point = getCoordinate(lat, lng, distance, degree);
      //       pointGroup.push(point);
      //     }
      //     pointArray.push(pointGroup);
      //   }

      //   if (this.distanceArray.length == 0) {
      //     pointArray.push([[lat, lng]]);
      //   } else {
      //     pointArray[0].push([lat, lng]);
      //   }

      //   // this._getAreas(pointArray)
      // this._getAreasCapRate(lat, lng, this.distance);
      this.delayOneSecond().then(() => {
        this._getAreasCapRate(lat, lng, this.distance);
      });
    },

    mapClickHandler: function (e) {
      let lat = e.latLng.lat();
      let lng = e.latLng.lng();

      this._getAreaHandler(lat, lng);
    },

    reCalcTotalCount: function (data) {
      // console.log("reCalcTotalCount", data, this.yearFrom, this.yearTo);
      var count = 0;
      for (let _data_index in data["data"]) {
        if (
          this.checkList.includes(data["data"][_data_index]["category_type"]) &&
          this.yearFrom <= data["data"][_data_index]["transaction_year"] &&
          this.yearTo >= data["data"][_data_index]["transaction_year"]
        ) {
          count += 1;
          if (data["data"][_data_index]["is_selected"]) {
            data["data"][_data_index]["is_selected"] = false;
          }
        }
      }
      data["total_count"] = count;
      return data;
    },
    reCalcMarker: function () {
      var _markers = { ...this.markers };
      for (let key in _markers) {
        _markers[key] = this.reCalcTotalCount(_markers[key]);
      }
      this.markers = _markers;
    },

    reSelectList: function () {
      var _selectList = [...this.selectList];
      for (let key in _selectList) {
        _selectList[key] = this.reCalcTotalCount(_selectList[key]);
      }
      this.selectList = _selectList;
    },
    // _clickedPolygonHandler: function (polygonObj) {
    //   var key = polygonObj.PrefectureName + polygonObj.CityName;

    //   if (this.cityInfo.hasOwnProperty(key)) {
    //     this.$delete(this.cityInfo, key);
    //     this.$delete(this.markers, key);
    //     return;
    //   }
    //   if (this._calculateCount(polygonObj) === 0) {
    //     return;
    //   }
    //   this.$set(this.cityInfo, key, polygonObj.Annual);
    //   if (polygonObj.AreaShape.length == 1) {
    //     this._addPolygonMarker(polygonObj);
    //   } else {
    //     this._addMultiPolygonMarker(polygonObj);
    //   }
    // },

    // _calculateCount: function (polygonObj) {
    //   if (
    //     Object.keys(polygonObj.Annual).length === 0 ||
    //     !polygonObj.Annual.hasOwnProperty(this.annual)
    //   ) {
    //     return 0;
    //   }

    //   var count = 0;

    //   for (const typeId of this.checkList) {
    //     count += polygonObj.Annual[this.annual][idTypeMapping[typeId]].Count;
    //   }

    //   return count;
    // },

    _getAreasCapRate: function (lat, lng, distance) {
      getAreasCapRate(lat, lng, distance)
        .then((res) => {
          // console.log(res);
          // console.log("checkList", this.checkList);
          this.enableRequest = true;
          if (res.data.code === 200) {
            this._cityInfo = res.data.AreasInfo;
            var areas = res.data.data.AreasInfo;
            var _markers = { ...this.markers };
            _markers = Object.assign(_markers, areas);
            if (areas == null) {
              return;
            }
            // console.log("取得時の条件に合わせてtotal_countを更新");
            // 取得時の条件に合わせてtotal_countを更新
            for (let key in _markers) {
              _markers[key] = this.reCalcTotalCount(_markers[key]);
            }
            this.markers = _markers;
          }
        })
        .catch((err) => {
          this.enableRequest = true;
        });
    },

    clickMarker: function (key) {
      this.$delete(this.selectList, key);
    },
  },
  created() {
    this.$bus.$on("annual", (annual) => {
      this.annual = annual;
    }),
      this.$bus.$on("year", (yearFrom, yearTo) => {
        console.log("update_year", yearFrom, yearTo);
        this.yearFrom = yearFrom;
        this.yearTo = yearTo;
        this.reCalcMarker();
        this.reSelectList();
      }),
      this.$bus.$on("checkList", (checkList) => {
        this.checkList = checkList;
        this.reCalcMarker();
        this.reSelectList();
      }),
      this.$bus.$on("deleteCheckList", (key) => {
        this.$delete(this.selectList, key);
      });

    // this.$bus.$on("selectOptions", (selectOptions) => {
    //   this.enableAppendMode = selectOptions.enableAppendMode;
    //   this.distance = selectOptions.sliderVal * 1000;
    //   switch (true) {
    //     case selectOptions.sliderVal > 24:
    //       this.distanceArray = [2, 4, 6, 8, 10, 12, 15];
    //       break;
    //     case selectOptions.sliderVal > 20:
    //       this.distanceArray = [2, 4, 6, 8, 10, 12];
    //       break;
    //     case selectOptions.sliderVal > 16:
    //       this.distanceArray = [2, 4, 6, 8, 10];
    //       break;
    //     case selectOptions.sliderVal > 12:
    //       this.distanceArray = [2, 4, 6, 8];
    //       break;
    //     case selectOptions.sliderVal > 10:
    //       this.distanceArray = [2, 4, 6];
    //       break;
    //     case selectOptions.sliderVal > 4:
    //       this.distanceArray = [2, 4];
    //       break;
    //     case selectOptions.sliderVal > 0:
    //       this.distanceArray = [2];
    //       break;
    //     default:
    //       this.distanceArray = [];
    //   }
    // }),
    //   (this._cityInfo = {});
  },
  mounted() {
    this.loaded = true;
    this.marker = { position: { lat: 10, lng: 10 } };
    this.$bus.$on("location", (location) => {
      this.marker.position = location;
      this.panToMarker();
      // this._getAreas()
    });
    this.loaded = true;
    this.$gmapApiPromiseLazy().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  },

  computed: {
    google: gmapApi,
    range() {
      return function (num) {
        switch (num) {
          case 4:
            return "0";
          case 3:
            return "1-9";
          case 2:
            return "10-29";
          case 1:
            return "30-99";
          default:
            return ">=100";
        }
      };
    },
    colorStyle() {
      return function (polygonObj) {
        if (polygonObj.Annual.hasOwnProperty(this.annual)) {
          return this.calculateColor(polygonObj.Annual[this.annual]);
        }
        return this.colors[4];
      };
    },
    storkeColorStyle() {
      return function (polygonObj) {
        if (
          this.cityInfo.hasOwnProperty(
            polygonObj.PrefectureName + polygonObj.CityName
          )
        ) {
          return "black";
        } else {
          return "black";
        }
      };
    },
    strokeWeightStyle() {
      return function (polygonObj) {
        if (
          this.cityInfo.hasOwnProperty(
            polygonObj.PrefectureName + polygonObj.CityName
          )
        ) {
          return 2;
        } else {
          return 1;
        }
      };
    },
    polygonCursorStyle() {
      return function (polygonObj) {
        if (this._calculateCount(polygonObj) === 0) {
          return "not-allowed";
        }
      };
    },
    loaderStyle() {
      if (this.enableRequest) return { display: "none" };
      if (!this.enableRequest) return { display: "flex" };
    },
    dialogStyle() {
      return {
        display: this.dialogStatus.display,
        position: "absolute",
        left: "",
        right: "",
      };
    },
  },
  watch: {
    loaded: {
      handler(newVal, oldVal) {
        this.geolocate();
      },
    },
  },
  beforeDestroy() {
    this.$bus.$off("location");
  },
};
</script>

<style scoped lang="scss">
.inner {
  padding-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
.button {
  width: 80px;
  height: 40px;
  display: flex;
  // border: px;
  // padding: 5px 15px;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  // box-shadow: 2px 2px 5px #000;
  // margin: 0 10px;
  cursor: pointer;
}
.close {
  background: #ffffff;
  color: rgb(0, 0, 0);
}
.select {
  background: #fbc02d;
  color: rgb(0, 0, 0);
}

#map-panel-container {
  display: flex;
  width: 100%;
  height: 100%;
}

.map {
  width: 100%;
  height: 100%;

  &-wrapper {
    width: 60%;
    flex: 1;
    min-width: 480px;
  }
}

#symbol {
  width: 100px;
  background-color: white;
  position: relative;
  bottom: 150px;
  left: 10px;
  border-radius: 4px;
  padding-bottom: 4px;

  &-text {
    font-size: 12px;
  }
}

.symbol-block {
  width: 128px;
  height: 24px;
  display: flex;
  font-size: 12px;
  align-items: center;
  position: relative;
  left: 10px;
}

.color-block {
  width: 24px;
  aspect-ratio: 1/1;
  margin-right: 4px;
}

/*Marker*/
.marker {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;

  & > span {
    color: black;
    display: block;
  }
}

/*loader*/

#preloader {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

#loader {
  display: block;
  position: relative;
  width: 25%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #001529;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

#loader:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1e1ece;
  -webkit-animation: spin 3s linear infinite;
  animation: spin 3s linear infinite;
}

#loader:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1e90ff;
  -webkit-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
